import { createStyles, makeStyles } from '@mui/styles';
import { ITheme } from 'theme/types';

const useStyles = makeStyles((theme: ITheme) => ({
  container: {
    marginTop: theme.spacing(5),
  },
  emptyMessageContainer: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'center',
  },
}));

export default useStyles;
